import styled from 'styled-components';

export const Footer = styled.div`
	background-color: #FFFFFF;
	border-top: 1px solid #D1D9E0;
	padding: 1rem 1.5rem;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 24px;
`;
